import type { Account } from '@shared/products-types';

import { useProductData } from './useProductData';
import type { UnderlyingProductWithHelpers } from '../types/underlyingProductWithHelpers';
import type { ProductWithHelpers } from '../types/productHelpers';
import type { AliasChange } from '../types/aliasChange';

function getUnderlyingProductData<UnderlyingData>(
    productWithHelpers: ProductWithHelpers<Account, UnderlyingData>,
): UnderlyingProductWithHelpers<UnderlyingData> {
    return {
        ...(productWithHelpers.underlyingData || ({} as UnderlyingData)),
        baseUrl: productWithHelpers.baseUrl,
        derivedType: productWithHelpers.derivedType,
        imageData: productWithHelpers.imageData,
        icon: productWithHelpers.icon,
        alternativeImageUrl: productWithHelpers.alternativeImageUrl,
        additionalData: productWithHelpers.additionalData,
        id: productWithHelpers.id,
        productId: productWithHelpers.productId,
    };
}

type UseUnderlyingProductReturn<UnderlyingData> = {
    data?: UnderlyingProductWithHelpers<UnderlyingData>;
    refetch: () => Promise<any>;
    updateAlias: AliasChange;
    isPending: boolean;
    error: any;
};

/** @deprecated do not introduce more usages of this hook in @retail or @business packages! */
export const useProduct = <UnderlyingData>(
    accountId: string,
): UseUnderlyingProductReturn<UnderlyingData> => {
    const { refetch, isPending, product, updateAlias, error } = useProductData<
        Account,
        UnderlyingData
    >(accountId);

    const underlyingProductData = product && getUnderlyingProductData<UnderlyingData>(product);

    return {
        refetch,
        isPending,
        data: underlyingProductData,
        updateAlias,
        error,
    };
};
